<template>
  <font-awesome-icon
    icon="comment"
    size="lg"
    class="icon"
    @click.stop="newMessage()"/>
</template>

<script>
export default {
  props: {
    user: {
      required: true,
      type: Object
    }
  },

  methods: {
    newMessage: function () {
      this.$router.push({
        name: 'user-message-new',
        params: { id: this.user.id }
      })
    }
  }
}
</script>

